

export const Getchecklist_data=(checklistId)=>{
                return $.get('Checklist/GetChecklistCategoryItems?checklistId='+checklistId)
  }

  export const GetChecklistGlossary=(model)=>{
    return $.post('Checklist/GetChecklistGlossary',model)
}



export const GetChecklistItemHelps=(checklistItemId)=>{
  return $.get('Checklist/GetChecklistItemHelps?checklistItemId='+checklistItemId)
}



export const GetChecklistItemHelpsByCode=(code,checklistId)=>{
  return $.get('Checklist/GetChecklistItemHelpsByCode?code='+code+'&checklistId='+checklistId)
}



export const AddChecklistRun = (model) => {

    return $.post('Checklist/AddChecklistRun', model)

  }

  export const GetChecklistRunDetails = (checklistRunId) => {
        
        return $.get('Checklist/GetChecklistRunDetails?checklistRunId='+checklistRunId)

}


export const UpdateChecklistRun = (model) => {

    return $.post('Checklist/UpdateChecklistRun', model)

  }


export const GetPdf_DIGICLARITY_THREW_ERROR_ON_209_UNKNOWN_NETWORK = (id) => {
  var xhr = new XMLHttpRequest();
  var auth = JSON.parse(localStorage.getItem('authentication'))
  xhr.open('GET',  window.baseUrl+'PDF/CheckList?checklistRunId='+id, true);
  xhr.responseType = 'arraybuffer';
  xhr.setRequestHeader("authorization", "bearer "+auth.access_token );
  xhr.onload = function(e) {
    loader.stopLoader()
    if (this.status == 200) {
      var blob=new Blob([this.response], {type:"application/pdf"});
      FileSaver.saveAs(blob, "checklist.pdf");
    }
  };
  xhr.send();
}

export const GetPdf = (id) => {
  var xhrOverride = new XMLHttpRequest();
  xhrOverride.responseType = 'arraybuffer';
  $.ajax({
      url: 'PDF/CheckList?checklistRunId='+id,
      method: 'GET',
      xhr: function() {
          return xhrOverride;
      }
  }).then(function (responseData) {
    var blob=new Blob([responseData], {type:"application/pdf"});
    FileSaver.saveAs(blob, "checklist.pdf");
  });
}


// WEBPACK FOOTER //
// ./src/components/checklist/checklist.services.js